module.exports = __webpack_public_path__ + "cf202695ca1efb133bc5a96c7e65fbcf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-22.png
// module id = 2566
// module chunks = 0